// extracted by mini-css-extract-plugin
export default {"BreadcrumbContainer":"ChannelSettings_BreadcrumbContainer__w+hoI"};